import Rx from 'rxjs/Rx';

class PageService {
  constructor($state, $transitions, $stateParams, SessionService) {
    'ngInject';

    this.$state = $state;
    this.$transitions = $transitions;
    this.$stateParams = $stateParams;
    this.SessionService = SessionService;

    this._subject$ = new Rx.BehaviorSubject(this._createEventFromState(this.$state.current));
    this._transitionEvents$ = this._subject$.asObservable();

    $transitions.onSuccess({}, (event) => {
      this._subject$.next(this._createEventFromState(this.$state.current));
    });
  }

  _createEventFromState(state) {
    let event = {};

    event['current'] = state.name;
    event['parent'] = state.parent;
    event['url'] = state.url;

    return event;
  }

  get transitionEvents() {
    return this._transitionEvents$;
  }

  goto(state) {
    this.$state.go(state);
  }

  getQueryParameters() {
    let parameters = {};
    for (let property in this.$stateParams) {
      if (this.$stateParams.hasOwnProperty(property)) {
        if (property !== '#') {
          parameters[property] = this.$stateParams[property];
        }
      }
    }
    
    return parameters;
  }

  // TODO: Remove this and use modal.util.js instead
  showModal(modalId = null) {
    if (modalId === null) {
      // TODO
    } else {
      $('#' + modalId).modal('show');
    }
  }
}

export default PageService;



// WEBPACK FOOTER //
// ./client/app/shared/ui/page.service.js